import { render } from "./OutStockDetail.vue?vue&type=template&id=f2e4383e&scoped=true"
import script from "./OutStockDetail.vue?vue&type=script&lang=js"
export * from "./OutStockDetail.vue?vue&type=script&lang=js"

import "./OutStockDetail.vue?vue&type=style&index=0&id=f2e4383e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e4383e"],['__file',"src/views/h5/luqiao/stockOrder/outStock/OutStockDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2e4383e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2e4383e', __exports__)) {
    api.reload('f2e4383e', __exports__)
  }
  
  module.hot.accept("./OutStockDetail.vue?vue&type=template&id=f2e4383e&scoped=true", () => {
    api.rerender('f2e4383e', render)
  })

}


export default __exports__